export interface AppEnvironment extends BaseEnvironment {
    production: boolean
}

interface BaseEnvironment {
    apiUrl: string
    publicApiUrl: string
    signUpUrl: string
    infoUrl: string
    wikiUrl: string
    rawImageLayerToken: string
    selectionAnnotationLayerName: string
}

export const BASE_ENVIRONMENT: BaseEnvironment = {
    apiUrl: '/api/v6',
    publicApiUrl: '/api/v6/public',
    signUpUrl: 'https://data.ariadne.ai/registerV',
    infoUrl: 'https://ariadne.ai/spatial/',
    wikiUrl: 'http://wiki.spatial.ariadne.ai/',
    rawImageLayerToken: 'rgb',
    selectionAnnotationLayerName: 'selection',
}
